import React from 'react';

interface ProcessCardProps {
  processNumber: string;
  processName: string;
  startDate: string;
  daysAgo: number;
  status: string;
  stages: {
    label: string;
    count: number;
  }[];
}

const ProcessCard: React.FC<ProcessCardProps> = ({ processNumber, processName, startDate, daysAgo, status, stages }) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-md mb-4">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-semibold">{processNumber} {processName}</h3>
        <button className="text-blue-500">Acciones</button>
      </div>
      <p className="text-sm text-gray-600">Proceso iniciado el {startDate} hace {daysAgo} días <span className="text-green-500">{status}</span></p>
      <div className="mt-2 grid grid-cols-6 gap-2 text-center text-gray-600">
        {stages.map((stage, index) => (
          <div key={index}>
            <p>{stage.count}</p>
            <p className="text-xs">{stage.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessCard;
